var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThunder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000004704"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000002467"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    d: "M33.9413 13.5065C34.9803 7.96534 29.266 3.63637 24.2444 6.23378C23.2054 2.59741 19.9153 0 15.9327 0C10.911 0 6.92833 4.329 7.27465 9.52381C3.1188 9.87013 0.00195312 13.3333 0.00195312 17.4892C0.00195312 21.9913 3.46517 25.4546 7.96733 25.4546H33.9413C37.2314 25.4546 40.002 22.8571 40.002 19.5671C40.002 16.277 37.5777 13.5065 33.9413 13.5065Z",
    fill: "url(#paint0_linear_312_3483)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_2",
    d: "M28.401 21.1259H19.2236L24.072 12.8142H13.163L8.31445 26.667H16.1067L12.6435 39.4809L28.401 21.1259Z",
    fill: "url(#paint1_linear_312_3483)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_312_3483",
    x1: -0.0828954,
    y1: 0.0415587,
    x2: 40.0037,
    y2: 0.0415587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#437AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67A4FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_312_3483",
    x1: 8.32484,
    y1: 12.7709,
    x2: 28.4114,
    y2: 12.7709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6DB00"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunder);
export default __webpack_public_path__ + "static/media/thunder.c282a5d3a793be7c81d572306ecab004.svg";
export { ForwardRef as ReactComponent };